import clsx from 'clsx';
import React from 'react';

import IconClose from '@components/Images/Rebranding/IconClose';

import StepNavigation, { StepNavigationProps } from './StepNavigation';

type Theme = 'dark' | 'light';

interface TooltipStepProps extends StepNavigationProps {
  children?: React.ReactNode;
  description: string;
  handleClose: () => void;
  showCloseButton?: boolean;
  theme?: Theme;
  title: string;
}

const TooltipStep = ({
  children,
  description,
  handleClose,
  handleNext,
  isProSubscriber,
  showCloseButton = true,
  step,
  theme = 'dark',
  title,
  totalSteps,
}: TooltipStepProps) => {
  const isDark = theme === 'dark';

  return (
    <div
      className={clsx('relative w-[416px] px-32 py-24', {
        'bg-grayscale-charcoal': isDark,
        'bg-white': !isDark,
      })}
    >
      {showCloseButton && (
        <button
          type="button"
          className={clsx(
            'absolute right-12 top-12 cursor-pointer touch-manipulation border-none bg-transparent p-0',
            isDark ? 'text-white' : 'text-black'
          )}
          onClick={handleClose}
          aria-label="Close"
        >
          <IconClose className="stroke-2" height={12} width={12} />
        </button>
      )}
      <h2
        className={clsx('my-0 font-suisse-screen text-headline-alt-sm font-medium', {
          'text-white': isDark,
          'text-black': !isDark,
        })}
      >
        {title}
      </h2>
      <p
        className={clsx('my-4 font-suisse-screen text-byline-lg', {
          'text-white': isDark,
          'text-black': !isDark,
        })}
      >
        {description}
      </p>
      {children}
      <StepNavigation
        handleNext={handleNext}
        isProSubscriber={isProSubscriber}
        step={step}
        stepCounterClassName={isDark ? 'text-grayscale-beige' : undefined}
        totalSteps={totalSteps}
      />
    </div>
  );
};

export default TooltipStep;
